import {Directive, ElementRef, HostListener, Input} from "@angular/core";
import {AbstractControl, FormGroup, NgModel} from "@angular/forms";
import {isNullOrUndefined} from "util";
import {ControlAccessors, InputModifierService} from "./input-modifier.service";

@Directive({
    selector: '[ngModel][removeWhiteSpaces]',
    host: {
        '(input)': 'onInput($event)'
    }
})
export class WhitespacesRemoveTdDirective {

    constructor(private _model: NgModel, private _inputModifier: InputModifierService) {
    }

    onInput(event) {
        this._inputModifier.transformControlValue<string>(ControlAccessors.forTemplateDrivenForm(this._model),
            event, this.transform)
    }

    transform(value: string): string {
        if(!value) {
            return null;
        }
        return value.replace(/\s+/g, '').trim();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/whitespaces-remove-td.directive.ts